// extracted by mini-css-extract-plugin
module.exports = {"title":"Report_title__2kp4h","text":"Report_text__16Nm_","info":"Report_info__3rKGX","input":"Report_input__2Glkk","btns":"Report_btns__3vjjY","button":"Report_button__3zByD"};